// ValidationScenarioLabel.tsx
import * as React from "react";
import { Chip, Typography } from "@mui/material";
import { Localized } from "@fluent/react";
import { ValidationScenario } from "../validationProcessApi";

type Mode = "text" | "chip";

type Props = {
    value?: string | null;
    mode?: Mode;                 
    size?: "small" | "medium"; 
    uppercase?: boolean;        
    fallbackText?: React.ReactNode; 
};

const MAP: Record<ValidationScenario, { id: string; fallback: string }> = {
    NEW: { id: "process-scenario-new", fallback: "_Walidacja nowego obiektu" },
    REQUAL_PERIODIC: { id: "process-scenario-requal-periodic", fallback: "_Rekwalifikacja okresowa" },
    REQUAL_CHANGE: { id: "process-scenario-requal-change", fallback: "_Rekwalifikacja po zmianach" },
};

export const ValidationScenarioLabel: React.FC<Props> = ({
    value,
    mode = "text",
    size = "small",
    uppercase = true,
    fallbackText = "-",
}) => {
    const key = (uppercase ? (value ?? "").toString().trim().toUpperCase() : (value ?? "")) as ValidationScenario;
    const entry = MAP[key];

    const labelNode = entry ? (
        <Localized id={entry.id}>
            <span>{entry.fallback}</span>
        </Localized>
    ) : (
        <>{fallbackText}</>
    );

    if (mode === "chip") {
        return <Chip size={size} label={labelNode} variant="outlined" />;
    }

    return (
        <>
          {labelNode}
        </>
    );
};
